import 'babel-polyfill';
import 'es6-promise/auto';
import React from 'react';
import axios from 'axios';
import {Provider, connect} from 'react-redux';
import ReactDOM, {render} from 'react-dom';
import {Router, useRouterHistory} from 'react-router';
import {createHistory} from 'history';
import createRoutes from './routes';
import configureStore, {sagaMiddleware, createRootSaga} from './store/configureStore';
import fetchData from './fetch-data';
import {wixAxiosConfig} from 'wix-axios-config';
import initSaga from './sagas/initSaga';
import reservationSaga from './sagas/reservationSaga';
import organizationSaga from './sagas/organizationSaga';
import I18nWebProvider from '@wix/restaurants-components/dist/shared/I18nProvider/I18nWebProvider';
import {clients} from 'wix-restaurants-js-sdk';

require('moment/locale/ar');
require('moment/locale/bg');
require('moment/locale/cs');
require('moment/locale/da');
require('moment/locale/de');
require('moment/locale/el');
require('moment/locale/es');
require('moment/locale/fi');
require('moment/locale/fr');
require('moment/locale/he');
require('moment/locale/hi');
require('moment/locale/hu');
require('moment/locale/id');
require('moment/locale/it');
require('moment/locale/ja');
require('moment/locale/ko');
require('moment/locale/ms');
require('moment/locale/nb');
require('moment/locale/nl');
require('moment/locale/pl');
require('moment/locale/pt');
require('moment/locale/ro');
require('moment/locale/ru');
require('moment/locale/sv');
require('moment/locale/th');
require('moment/locale/tr');
require('moment/locale/en-gb');

const initialState = window.__INITIAL_STATE__;
const baseURL = window.__BASEURL__;
const rootElement = document.getElementById('root');
wixAxiosConfig(axios, {baseURL});

const store = configureStore(initialState, axios, XMLHttpRequest);
const history = useRouterHistory(createHistory)({basename: baseURL});
const routes = createRoutes(store);
const sagas = [initSaga.saga, reservationSaga.saga, organizationSaga.saga];
sagaMiddleware.run(createRootSaga(sagas, {restClient: clients.createRestClient({timeout: 0})}));
const I18nWebProviderConnected = connect(state => ({localeData: state.i18nData.localeData}))(I18nWebProvider);

// For StaticMap
window.ReactDOM = ReactDOM;

render(
  <Provider store={store}>
    <I18nWebProviderConnected Intl={Intl}>
      <Router history={history} onUpdate={onUpdate}>
        {routes}
      </Router>
    </I18nWebProviderConnected>
  </Provider>,
  rootElement
);

function onUpdate() {
  const {components, params} = this.state;
  if (window.__INITIAL_STATE__ !== null) {
    return window.__INITIAL_STATE__ = null;
  }
  return fetchData(store.dispatch, components, params);
}



// WEBPACK FOOTER //
// ./client.js